import { useEffect } from 'react';

import { useSectionsNavigation } from '../../context/hooks/useSectionsNavigation';

export function SkippedSectionComponent() {
  const { onNextSectionClick } = useSectionsNavigation();

  useEffect(() => {
    onNextSectionClick?.();
  }, [onNextSectionClick]);

  return null;
}
